import { render } from "./EmptyLayout.vue?vue&type=template&id=d1c119ee"
const script = {}

import exportComponent from "/builds/check-marq/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__